if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
        
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
        
          var variantid = formData.get('id'),
          	  addonQtyElm = document.querySelector('[data-variant-' + variantid + ']'),
          	  accessories = document.querySelectorAll('[name="accessories"]'),
              addons = document.querySelectorAll('[name="addons"]'),
              checkedAccessories = [],
              addonQty = addonQtyElm ?  Number(addonQtyElm.innerHTML) : 1;
        
        	if(addons.length || accessories.length){
              addons.forEach(item => {
                if(item.checked){
                	checkedAccessories.push({
                      quantity:  response.quantity * (addonQty || 1),
                      id: item.value,
                      properties: {
                        '_addon': response.sku
                      }
                    })
                }
              })
              
              accessories.forEach(item => {
                if(item.checked){
                	checkedAccessories.push({
                      quantity: 1,
                      id: item.value,
                      properties: {
                        '_addon': response.sku
                      }
                    })
                }
              })
              
              if(checkedAccessories.length){
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                  	body: JSON.stringify({
                      items: checkedAccessories
                    })
                 }).then(response => {
                    return response.json();
                 }).catch((error) => {
                    console.error('Error:', error);
                 });
              }
              
            }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
